<div>
    <div bsModal #goDigitalModal="bs-modal" id="goDigital" class="modal fade" role="dialog"
         [config]="{ backdrop: 'static' }">
        <div class="modal-dialog modal-lg-custom">
            <div class="modal-content p-4">
                <p class="modal-title text-center py-3 clearfix bshadow0 pbs">
        <span class="icon-Group-3619"><span class="path1"></span><span class="path2"></span><span class="path3"></span>
        </span> Go Digital. Go Paperless.</p>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-md">
                            <h2 class="pb-2">Save Time</h2>
                            <h2 class="pb-2">Easy to Access</h2>
                            <h2 class="pb-2">Easy to Manage</h2>
                        </div>
                        <div class="col-md go-digi pl-3">
                            <div>
                <span>
                <p>Policies:</p>
                <ul>
                  <li *ngFor="let policy of edocsUnenrolledPolicyNumbers">{{ policy }}</li>
                </ul>
              </span>
                            </div>
                            <div>
                                <p>Manage your Tower Hill policy documents, track your claim, and make payments
                                    online.</p>
                                <p class="text-right go-green">Go Paperless Today!</p>
                            </div>
                        </div>
                    </div>
                    <div class="go-digi">
                        <p class="pr-1 pb-1 pt-1">
                            Please note that agreeing to these terms and conditions will enroll all current policies in
                            your Customer Portal account in paperless delivery.
                            Policies may be unenrolled at any time by updating your Customer Portal preferences.
                        </p>
                    </div>
                    <div class="primary-textcolor">
                        <p>Terms & Conditions</p>
                        <p>
            <span class="pr-1">
              <p-checkbox [binary]="true" [(ngModel)]="isChecked"></p-checkbox>
            </span>
                            I have read and agree to the <a href="/api/termsandconditionsFile/EDOC/TX"
                                                            class="pl-2 terms_link" target="_blank">terms
                            and conditions </a>
                        </p>
                    </div>
                    <div *ngIf="isChecked && !cellPhoneNumber" class="mb-3">
            <span class="go-digi pb-1 mobile-label">
              Please provide your mobile phone number to receive important policy and claim updates via text message.
              Message and data rates may apply. Text STOP to cancel at any time.
            </span>
                        <div class="mt-3">
                            <form [formGroup]="goDigitalForm" autocomplete="off">
                                <div>
                                    <input class="form-control mobile-field" size="20"
                                           (blur)="mobileValue(goDigitalForm.controls['phone'].value)"
                                           placeholder="Phone Number" maxlength="12"
                                           [value]="goDigitalForm.controls['phone'].value | phoneNo"
                                           oncopy="return false"
                                           onpaste="return false" pattern="^\d{3}[\-]\d{3}[\-]\d{4}$"
                                           formControlName="phone" (keypress)="restrictBackspace($event)">
                                </div>
                                <div class="text-danger"
                                     *ngIf="(goDigitalFormSubmitted || goDigitalForm.controls['phone'].touched ) &&
                 goDigitalForm.controls['phone'].hasError('required')">
                                    Phone is required
                                </div>
                                <div class="text-danger"
                                     *ngIf="showPhoneErrMsg">
                                    {{ showPhoneErrMsg }}
                                </div>
                                <div class="text-danger"
                                     *ngIf="showMobileErrMsg">
                                    {{ showMobileErrMsg }}
                                </div>
                            </form>
                        </div>
                    </div>
                    <div id="actionButtons" class="d-flex">
                        <div class="col pl-0">
                            <button id="enroll" class="btn btn-primary py-2" *ngIf="isChecked"
                                    (click)="eDocsEnrollment();">Enroll
                            </button>
                            <button id="enroll" class="btn btn-primary py-2" *ngIf="!isChecked" disabled>Enroll</button>
                        </div>
                        <div class="px-0 col text-center pt-1">
                            <a class="no-thanks" (click)="eDocsNoThanks()">No Thanks</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<!--Go Digital popup 2-->
<div bsModal #digitalDetails="bs-modal" id="digitalDetails" class="modal fade" role="dialog">
    <div class="modal-dialog modal-lg-custom enroll_popoup">
        <div class="modal-content p-3">
            <div class="glyph fs1 iconClose cursor-pointer position-absolute">
                <div class="clearfix bshadow0 pbs">
          <span class="icon-Group-3621" (click)="digitalDetails.hide();"><span class="path1"></span><span
                  class="path2"></span><span
                  class="path3"></span></span>
                </div>
            </div>
            <div class="modal-titleCont text-center">
                <p class="modal-title text-center py-3 clearfix bshadow0 pbs">
          <span class="icon-Group-3619"><span class="path1"></span><span class="path2"></span><span
                  class="path3"></span>
          </span> Go Digital. Go Paperless.</p>

                <p class="mb-2">What's next?</p>
            </div>
            <div class="modal-body py-0">
                <p class="text-left linkUrl">
                    <a routerLink="/user-profile/my-preferences">
                        Manage your preferences
                    </a>
                </p>
                <p>E-mail notifications for policies will be sent to <span class="notification-email">{{ email }}
                    . </span>
                </p>
                <p class="text-center">
                    <button class="btn btn-primary py-1 px-5 mx-auto text-center" (click)="digitalDetails.hide()">Done
                    </button>
                </p>
            </div>
        </div>
    </div>
</div>

